import ContentPopoverEmptyState from '../../../draft-content-transplant/ContentPopoverEmptyState';
import { getDocumentsUrl } from '../../../draft-transplant/utils/links';
import { jsx as _jsx } from "react/jsx-runtime";
const DocumentsPopoverEmptyState = () => /*#__PURE__*/_jsx(ContentPopoverEmptyState, {
  image: "documents",
  title: "hubspot-prosemirror.documents.popover.zeroState.header",
  description: "hubspot-prosemirror.documents.popover.zeroState.description",
  buttonLabel: "hubspot-prosemirror.documents.popover.zeroState.button",
  buttonLink: getDocumentsUrl()
});
export default DocumentsPopoverEmptyState;